export enum DsArea {
    Standard = 0,
    Advanced = 1
}
